/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Chinmaya",
  logo_name: "Chinmaya",
  nickname: "Chinmaya",
  full_name: "Chinmaya Tripathi",
  subTitle:
    "Software Engineer, Open Source Enthusiast 🔥.",
  resumeLink:
    "https://drive.google.com/file/d/17GR-isY6piigS0Fh0R5JabOMMtOEMOrw/view?usp=sharing",
  mail: "mailto:chinmayatripathi30@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/chinmaytrpth2",
  linkedin: "https://www.linkedin.com/in/chinmayatripathi/",
  gmail: "chinmayatripathi30@gmail.com",
  gitlab: "https://gitlab.com/",
  facebook: "https://www.facebook.com/chinmay.tripathi.56/",
  twitter: "https://twitter.com/chinmaytrpth2",
  instagram: "https://www.instagram.com/chinmaytripathi/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Design and develop highly interactive UI for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using React Native and Kotlin",
        "⚡ Creating application backend in Node, Express & GraphQL",
        "⚡ Integration of third party services such as Firebase / AWS / Azure / GCP"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        {
          skillName: "Visual Basic",
          fontAwesomeClassname: "simple-icons:dot-net",
          style: {
            color: "#029FCE",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "The University of Texas at Arlington",
      subtitle: "Master of Science in Computer Science",
      logo_path: "uta.png",
      alt_name: "UTA",
      duration: "2021 - Present",
      descriptions: [
        "⚡ I'm currently pursuing my masters in Computer Science.",
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "http://www.uta.edu/",
    },
    {
      title: "Dr. A.P.J Abdul Kalam Technical University",
      subtitle: "Bachelor of Technology in Computer Science",
      logo_path: "aktu.png",
      alt_name: "AKTU",
      duration: "2014 - 2018",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "http://www.aktu.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Complete ReactJS",
      subtitle: "Udemy",
      logo_path: "reactjs.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      color_code: "#fffbf3",
    },
    {
      title: "MongoDB developer course",
      subtitle: "Udemy",
      logo_path: "mongo.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
    color_code: "#b190b0",
    },
    {
      title: "Complete NodeJS and GraphQL",
      subtitle: "Udemy",
      logo_path: "node.jpg",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#47A048",
    },
    {
      title: "Machine Learning - Andrew Ng",
      subtitle: "Coursera",
      logo_path: "ml1.png",
      certificate_link:
        "",
      alt_name: "Coursera",
      // color_code: "#2AAFED",
      color_code: "#fffbf3",
    },
    {
      title: "Data science and Machine learning Bootcamp",
      subtitle: "Udemy",
      logo_path: "ml2.jpeg",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#2AAFED",
    },
    {
      title: "MERN Stack development",
      subtitle: "Udemy",
      logo_path: "mern.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#fe0037",
    },
    {
      title: "React Native",
      subtitle: "Udemy",
      logo_path: "reactjs.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#fffbf3",
    },
    {
      title: "Ethical hacking",
      subtitle: "Flutter International Hackathon",
      subtitle: "Udemy",
      logo_path: "hacker1.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#2AAFED",
    },
    {
      title: "Cyber security: Hackers exposed!",
      subtitle: "Udemy",
      logo_path: "hacker2.jpeg",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#fffbf3",
    },
    {
      title: "Social Engineering",
      subtitle: "Udemy",
      logo_path: "se.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#fffbf3",
    },
    {
      title: "Network Hacking and Security",
      subtitle: "Udemy",
      logo_path: "network.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      // color_code: "#2AAFED",
      color_code: "#fffbf3",
    },
    {
      title: "JAVA",
      subtitle: "Udemy",
      logo_path: "java.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      color_code: "#C5E2EE",
    },
    {
      title: "Sketch 3",
      subtitle: "Udemy",
      logo_path: "sketch.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      color_code: "#0C9D5899",
      // color_code: "#fffbf3",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed one internship. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Housing Ambassador",
          company: "The University of Texas at Arlington",
          company_url: "https://uta.edu/housing",
          logo_path: "uta.png",
          duration: "Apr 2021 - Present",
          location: "Part Time",
          description:
          `Help & answer questions and familiarize students to our exciting campus life. Not only do Housing Ambassadors share experiences of living on campus with prospective 
          students and their families, but lead daily Housing Tours of our residence halls and apartments, answer housing 
          and dining questions at the front desk of the University Housing office, work at on-campus events and fairs, and help students with online housing application process.`,
          color: "#0071C5",
        },
        {
          title: "Full Stack Engineer",
          company: "TimesGlobacom Pvt Ltd",
          company_url: "http://timesworld.in",
          logo_path: "times.png",
          duration: "Jul 2018 - Dec 2018",
          location: "New Delhi",
          description:
          `
          •	Technologies used - Bootstrap, jQuery, NodeJS, ReactJS, Php, MySQL. 
          •	Defined and conducted the project at all stages, including research, conceptualization, testing and implementation.
          •	Single handedly, built a Company Relationship Management (CRM) tool which includes task, leave, attendance, leads and KRA management.
          •	Modified existing software systems to enhance performance and produced high-impact, user-friendly websites that accomplished all business goals.
          •	Validated code for proper structuring, security and compatibility with different browsers, devices, or operating systems.
          `,
            // "Created Front end of Yearn Financial Mutual Funds website. also degined simple web application for better user experience, designed DB Schemas as well.",
          color: "#ee3c26",
        },
        {
          title: "Before the court - Freelance Web developer ",
          company: "Freelance",
          company_url: "",
          logo_path: "freelancer.jpeg",
          duration: "Feb 2018 - Jul 2018",
          location: "New Delhi",
          description:
          `•	Technologies used - Mongo, Node, Express, React (MERN)
          •	Worked with Capital Via on their ERP Tool. Developing individual modules and integrating them.
          •	Crafted mobile-friendly websites and transitioned legacy site to mobile-friendly platform.
          •	Built and applied reusable code to other projects to reduce consulting fees and development hours.
          `,
            // "Created Front end of Yearn Financial Mutual Funds website. also degined simple web application for better user experience, designed DB Schemas as well.",
          color: "#ee3c26",
        }
      ],
    },
    {
      title: "Internship",
      experiences: [
        {
          title: "SWE Intern",
          company: "Evergreen Softtech Solutions",
          company_url: "http://evergreensofttech.in/",
          logo_path: "evergreen.jpeg",
          duration: "Jun 2027 - Jul 2017",
          location: "Lucknow",
          description:
            `•	Technologies used - HTML5, CSS3, JS, jQuery, Bootstrap, Php.
            •	Demonstrated enthusiasm and strong communication skill, remaining open to learning new things every day.
            •	Participated in weekly staff meetings and team building events. Analyzed and prioritized multiple responsibilities.
            •	Worked on a government project named "Madhyanished Vibhaag", for an anti-drug organization by building their website.
            •	Adhered to strict security protocols to protect data confidentiality.
            `,
          color: "#4285F4",
        },
      ],
    },
    {
      title: "Volunteership",
      experiences: [
        {
          title: "Production Assistant",
          company: "BMW AUTO EXPO",
          company_url: "",
          logo_path: "bmw.png",
          duration: "1 month",
          location: "Part Time",
          description:
          `Help & answer questions and familiarize students to our exciting campus life. Not only do Housing Ambassadors share experiences of living on campus with prospective 
          students and their families, but lead daily Housing Tours of our residence halls and apartments, answer housing 
          and dining questions at the front desk of the University Housing office, work at on-campus events and fairs, and help students with online housing application process.`,
          color: "#0071C5",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Full Stack developer primarily focused on JavaScript with a strong knowledge in React, Node, Typescript and Python.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "chinmaya.jpg",
    description:
      "Have something is mind? Looking for collaboration? Feel free to reach out to me... ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Visit my Blog here",
    link: "https://dev.to/chinmaytrpth2",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Covid'19 Tracker",
      url: "https://github.com/chinmaytrpth2/Covid-19-Tracker-App",
      description: "A web app to track global stats for Covid'19.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Typescript",
          iconifyClass: "logos-typescript",
        },
      ],
    },
    {
      id: "1",
      name: "CRM — Tool ",
      url: "",
      description:
        "Developed an entire Company Relationship Management tool for the company alone, which includes Task, Leave, Attendance, Leads, KRA management.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      id: "2",
      name: "Diaspove",
      url: "",
      description:
        "A social networking app for Venezuelans to socialize in a foreign country with other Venezuelans, explore places and help the community grow stronger.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "3",
      name: "Housing management Tool",
      url: "",
      description:
        "Developed an entire tool to manage a housing system, containing apartments, buildings and sub-divisions providing different level dashboards.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Laravel",
          iconifyClass: "logos-laravel",
        },
        {
          name: "MySQL",
          iconifyClass: "logos-mysql",
        },
      ],
    },
    {
      id: "4",
      name: "Anvarat.org",
      url: "www.anvarat.org",
      description:
        "Women Empowerment Organization - Website for the Non-profit Organization",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Wordpress",
          iconifyClass: "logos-wordpress",
        },
      ],
    },
    {
      id: "4",
      name: "SassyCSS",
      url: "https://github.com/chinmaytrpth2/sassy-css",
      description:
        "A CSS framework - A CSS framework providing different CSS skins and plugins for raw HTML skeleton.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Javascript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "5",
      name: "chinmayatripathi.github.io",
      url: "https://github.com/harikanani/harikanani.github.io",
      description:
        "A Personal Portfolio Website that showcases my work and experience. which is hosted on Github Pages.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "SCSS",
          iconifyClass: "vscode-icons:file-type-scss2",
        },
      ],
    },
    {
      id: "6",
      name: "CrackLoopHole",
      url: "https://github.com/chinmaytrpth2/CrackLoopHole",
      description:
        "Online assessment tool - An online assessment tool for universities and organizations to conduct test remotely.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      id: "7",
      name: "grapecodes.com",
      url: "",
      description:
        "Social networking platform for developers - A website help developers worldwide to share their code.",
      languages: [
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "MySQL",
          iconifyClass: "logos-mysql",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
      ],
    },
    {
      id: "8",
      name: "Youtube-Clone",
      url: "https://github.com/chinmaytrpth2/Youtube-Clone",
      description:
        "A Simple React app which clones YouTube features, giving user a more customized feel.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Typescript",
          iconifyClass: "logos-typescript",
        },
      ],
    },
    {
      id: "9",
      name: "Anywhere Weather",
      url: "https://github.com/chinmaytrpth2/Anywhere-Weather",
      description:
        "React app to tell weather forecast.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
